export const DEPARTMENT = '/department/' as const
export const DEPARTMENT_ALL = `${DEPARTMENT}all` as const
export const DEPARTMENT_LABELS = `${DEPARTMENT}label` as const
